export default __webpack_public_path__ + "static/media/search_startup.320b1332.png";